import React from 'react';
import img from '../Pages/image/project-4.png'

const CaseStudy = () => {
    return (
        <div>
            <section class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 lg:py-24 py-8 md:flex-row flex-col items-center">
        <div class=" md:w-1/2 w-full mb-10 md:mb-0">
            <img class="object-cover object-center rounded shadow" alt="hero" src={img} />
          </div>
          <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow text-left lg:pr-12 lg:px-0 px-5">
                <h1 class="lg:text-6xl text-4xl lg:text-left text-center mb-4 font-bold gradient  ">Patient Care Solution Case Study
                </h1>
                <p class="mb-8 leading-relaxed text-white lg:text-left text-center">Patient Care Solution is a Real life experienced based problem solving Project.Project Started with user research,user interview,User analysis, userflow, low fadility wireframe,Hight fiedlity Mockup.Read more about the case study click on Button </p>
                <div className=""><button class="btn btn-outline border bg shadow mt-5 "><a className='text-white' href='https://www.behance.net/gallery/151613079/Doctor-Consulting-Process-Solution-System' target="_blank" rel='noopener noreferrer'>Case Study</a></button></div>
              </div>
            </div>
            <div className='grid grid-rows grid-flow-col mb-5 ' >
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>Figma</p> </div>
              <div  className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg text-left mb-8'>Balsamiq</p> </div>
              <div  className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg text-left mb-8'>XD</p> </div>
              <div  className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg text-left mb-8'>Pen & Paper</p> </div>
              </div>
      
            <div className=""><button class="btn btn-outline border hover:bg-cyan-400  mt-5 "><a className='text-white' href='https://search-doctor-c5b9c.web.app/' target="_blank" rel='noopener noreferrer'>Demo</a></button></div>

          </div>
      
        </div>
      </section>
        </div>
    );
};

export default CaseStudy;